import React from 'react';
import * as Scroll from 'react-scroll';
import styles from './ScrollButton.module.scss';

const ScrollButton = ({ ...buttonProps }) => (
  <Scroll.Link className={styles.root} {...buttonProps} smooth>
    <div className={styles.background}>
      <svg xmlns="http://www.w3.org/2000/svg" width="62" height="86" viewBox="0 0 62 86">
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
          <circle cx="30" cy="30" r="30" stroke="#4A4E57" />
          <path stroke="#4A4E57" strokeLinecap="square" d="M29.5 83.5v-39" />
          <path
            fill="#FFF"
            d="M25.712 78.293l3.88 3.88 3.88-3.88a.996.996 0 1 1 1.41 1.41l-4.59 4.59a.996.996 0 0 1-1.41 0l-4.59-4.59a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z"
          />
        </g>
      </svg>
    </div>
    <div className={styles.caption}>&nbsp;Scroll</div>
  </Scroll.Link>
);

export default ScrollButton;
